export default "__VITE_ASSET__C$GIJtpB__"